import type { ReactNode } from "react";
import "./ScheduleDateNavigator.scss";
import type { ScheduleRange } from "@/pages/human-resources/time-management/model/ScheduleRange.ts";
import DateNavigator from "@/shared/components/generic/date/date-navigator/DateNavigator.tsx";
import MonthlyDateNavigator from "@/pages/human-resources/time-management/components/date-navigator/monthly-date-navigator/MonthlyDateNavigator.tsx";
import type { DateTime } from "luxon";

interface Properties {
  timeZone: string;
  value: DateTime;
  onChange: (d: DateTime) => void;
  viewRange: ScheduleRange;
}

export default function ScheduleDateNavigator(props: Properties): ReactNode {
  switch (props.viewRange) {
    case "DAY":
      return (
        <DateNavigator
          timeZone={props.timeZone}
          value={props.value}
          onChange={props.onChange}
        />
      );
    case "WEEK":
      return undefined; // Not implemented yet
    case "MONTH":
      return (
        <MonthlyDateNavigator
          timeZone={props.timeZone}
          value={props.value}
          onChange={props.onChange}
        />
      );
  }
}
